import gql from 'graphql-tag';
import { IResolvers, AllContextFragmentDoc, CacheTypenames, IAllContextFragment, IClientService  } from '@workbench-stack/core';

const EDITOR_CONTEXT_FRAGMENT = gql`
    fragment context on Context {
        resource
        resourceSet
        resourceScheme
        resourceLangId
        resourceExtName
        resourceFilename
        isFileSystemResource
    }
`;

const contextResolvers: (services: () => IClientService) => IResolvers = (services) => ({
    Query: {
        getContextProperty(_, {  }, { cache, getCacheKey }) {
            try {
              const data = cache.readFragment({
                fragment: EDITOR_CONTEXT_FRAGMENT,
                  id: getCacheKey({ __typename: CacheTypenames.Context }),
              });
              return data;
            } catch (err) { }
        },
        getContextData(parent, args, context) {
            return context.cache.readFragment<IAllContextFragment>({
                fragment: AllContextFragmentDoc,
                id: context.getCacheKey({ __typename: CacheTypenames.Context }),
            });
        },
        selectedResource: (parent, args, context) => {
            // return context.client.container.resourceContextKey.get() as any;
            return services().resourceContextKey.get() as any;
        },

    },
    Mutation: {
        updateContext: (_, args, context) => {
            // context.client.container.contextKeyService.setContext(args.key, args.value);
            services().contextKeyService.setContext(args.key, args.value);
            return true;
        },
        updateSelectedResource: (parents, { resource }, context ) => {
            //   context.client.container.resourceContextKey.set(resource);
            services().resourceContextKey.set(resource);
            return true;
        },
    },
});

export { contextResolvers };
